var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import cadService from "@/core/services/cadService";
import JwtService from "@/core/services/JwtService";
import { Formas_de_PagamentoActions } from "@/store/enums/CadEnums";
import { Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Formas_de_PagamentoModule = class Formas_de_PagamentoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Formas_de_PagamentoActions.POST_FORMAS_DE_PAGAMENTO](data) {
        return new Promise(resolve => {
            cadService.post("Formas_de_Pagamento/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Formas_de_PagamentoActions.PUT_FORMAS_DE_PAGAMENTO](data) {
        return new Promise(resolve => {
            cadService.put("Formas_de_Pagamento/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Formas_de_PagamentoActions.DELETE_FORMAS_DE_PAGAMENTO](data) {
        return new Promise(resolve => {
            cadService.delete("Formas_de_Pagamento/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Formas_de_PagamentoActions.DELETE_RANGE_FORMAS_DE_PAGAMENTO](data) {
        return new Promise(resolve => {
            cadService.delete("Formas_de_Pagamento/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Formas_de_PagamentoActions.FILTER_FORMAS_DE_PAGAMENTO](data) {
        return new Promise(resolve => {
            cadService.post("Formas_de_Pagamento/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Formas_de_PagamentoActions.GET_FORMAS_DE_PAGAMENTO]() {
        return new Promise(resolve => {
            cadService.get("Formas_de_Pagamento/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Formas_de_PagamentoActions.GETWITHDISABLED_FORMAS_DE_PAGAMENTO]() {
        return new Promise(resolve => {
            cadService.get("Formas_de_Pagamento/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Formas_de_PagamentoActions.GET_BY_ID_FORMAS_DE_PAGAMENTO](data) {
        return new Promise(resolve => {
            cadService.get("Formas_de_Pagamento/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Formas_de_PagamentoModule.prototype, _h, null);
Formas_de_PagamentoModule = __decorate([
    Module
], Formas_de_PagamentoModule);
export default Formas_de_PagamentoModule;
//# sourceMappingURL=Formas_de_PagamentoModule.js.map